import React from 'react'
import { Link } from 'react-router-dom'

type AboutContentProps = {
  staticLinks?: boolean
}

const AboutContent = ({ staticLinks }: AboutContentProps) => {
  const PrivacyPolicyLink = staticLinks ? (
    <a href='/privacy'>Privacy Policy</a>
  ) : (
    <Link to='/privacy'>Privacy Policy</Link>
  )

  return (
    <>
      <h2 id='what-is-tiny-invoice'>What is TinyInvoice.app?</h2>
      <p>
        TinyInvoice.app is a simple <b>online invoicing tool for freelancers, independent professionals, and small business owners</b> who want an easy way to create and send invoices without dealing with complicated accounting software.
      </p>
      <p>
        You can create an invoice, download it as a PDF, send it directly to your client by email, and keep track of whether it has been paid. TinyInvoice.app is designed to handle the essential parts of invoicing without adding unnecessary complexity.
      </p>

      <h2 id='why-tiny-invoice'>Why TinyInvoice.app?</h2>
      <p>
        Creating and managing invoices shouldn't require a spreadsheet, complicated software, or a long setup process. TinyInvoice.app is designed to be simple, easy to use, and get you paid faster.
      </p>
      <p>
        TinyInvoice.app was created with a simple idea: <b>invoicing should be simple</b>.
      </p>
      <p>Many invoicing and accounting platforms offer dozens of features, menus, reports, and settings. While those tools can be useful for larger businesses, they can also make a simple task feel unnecessarily complicated.</p>
      <p>TinyInvoice.app focuses on the things small businesses actually need to invoice their clients and keep track of payments.</p>

      <h2 id='who-runs-tiny-invoice'>Built by an independent developer</h2>
      <p>
        I am <strong>Nicolás Fetter</strong> (
        <a href='https://x.com/nicofetter' target='_blank' rel='noreferrer'>@nicofetter</a>
        {' '}on X), the solo developer behind TinyInvoice.app. I started working on it in <strong>2023</strong> and have continued adding new features and improvements since then.
      </p>
      <p>The product started with a simple goal: build an invoicing tool that is fast, straightforward, and doesn't make users learn a complicated system before they can send an invoice.</p>
      <p>If you have a suggestion, find something that doesn't work as expected, or think TinyInvoice.app could be improved, feedback is always welcome.</p>
      <p>
        You can reach me at <a href='mailto:info@tinyinvoice.app'>info@tinyinvoice.app</a>.
      </p>

      <h2 id='privacy'>Privacy</h2>
      <p>
        TinyInvoice.app does <strong>not</strong> use third-party advertising trackers to follow
        you around the web, and we do <strong>not</strong> build a business model around selling any of your data. For the full picture, read our{' '}
        {PrivacyPolicyLink}.
      </p>
    </>
  )
}

export default AboutContent
